import {
  trans,
  setLocaleFallbacks,
  throwWhenNotFound,
  getLocale,
} from '@symfony/ux-translator'

import { localeFallbacks } from '../var/translations/configuration'

setLocaleFallbacks(localeFallbacks)
throwWhenNotFound(true)

export { trans, getLocale }

export * from '../var/translations/index.js'
